module.exports = __webpack_public_path__ + "img/prev-arrow_l.6bc4f677.svg";